import { Button } from 'antd';
import { useCallback, useState } from 'react';
import List from 'src/components/grid.component/index'
import { AddresssHandler, AmountHandler, CreditHandler, DateHandler, StatusHandler, TransactionHash } from './service';
import TopUpTransactions from './topUpTransactions';
const RecentTopup = ({ setIsTopupGridRefresh, isTopupGridRefresh }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsModalVisible(false);
  }, [])
  const handleHash = useCallback((data) => () => {
    window.open(data.url)
  }, [])
  const topupTransactionHandler = useCallback((data) => {
    return <TransactionHash data={data?.dataItem} handleHash={handleHash} />
  }, [])
  const addressHandler = useCallback((data) => {
    return <AddresssHandler data={data?.dataItem} />
  }, [])
  const creditHandler = useCallback((data) => {
    return <CreditHandler data={data?.dataItem} />
  }, [])
  const dateHandler = useCallback((data) => {
    return <DateHandler data={data?.dataItem} />
  }, [])
  const statusHandler = useCallback((data) => {
    return <StatusHandler data={data?.dataItem} />
  }, [])
  const amountHandler = useCallback((data) => {
    return <AmountHandler data={data?.dataItem} />
  }, [])
  const customcells = {
    "transactionhash": topupTransactionHandler,
    "address": addressHandler,
    "credits": creditHandler,
    "date": dateHandler,
    "status": statusHandler,
    "amount": amountHandler
  };
  const renderCustomCell = useCallback((props, column) => {
    if (customcells[column.field]) {
      return customcells[column.field](props);
    }
  }, [customcells])
  const refreshCallBack = useCallback(() => {
    setIsTopupGridRefresh(false);
  }, []);
  return (
    <div className='mt-5'>
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-2xl font-semibold text-titleColor">
          Recent Topup
        </h2>
        <Button type="default" className=" cancel-btn !px-4 !py-1 !h-auto" onClick={showModal}>
          See All
          <span className="icon icon-arrow-right ml-2"></span>
        </Button>
        {isModalVisible && <TopUpTransactions visible={isModalVisible} onClose={handleClose} />}
      </div>
      <List
        url={process.env.REACT_APP_API_END_POINT + `/api/v1/energy/Topupk/null/null/null`}
        pSize={5}
        className="custom-grid"
        pageable={false}
        screenName={'Energy_TopUp_Transactions'}
        renderCustomCell={renderCustomCell}
        refresh={isTopupGridRefresh}
        refreshCallBack={refreshCallBack}
      />
    </div>
  );
}

export default RecentTopup;